import axios from 'axios';
import apiConfig from '../api.config';

export default function forcePoliceReportDownloadTrigger({ hotelId, date }) {
  const {
    host,
    URIs: { policeReportDownloadTrigger },
  } = apiConfig;

  const uri = `${host}${policeReportDownloadTrigger}`;

  return axios
    .post(uri, JSON.stringify({ hotel: { id: hotelId }, date }), {
      headers: { 'Content-Type': 'application/json' },
    })
    .then(res => {
      return res.data;
    });
}
